
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/detail",
      function () {
        return require("private-next-pages/campaign/detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/detail"])
      });
    }
  